import { configureStore } from '@reduxjs/toolkit';
import addressReducer from "../features/address/addressSlice";
import cartReducer from "../features/cart/cartSlice";
import inventoryReducer from "../features/inventory/inventorySlice";
import orderReducer from "../features/order/orderSlice";
import searchReducer from "../features/search/searchSlice";
import { graceApi } from "../services/grace";

const store = configureStore({
    reducer: {
        address: addressReducer,
        cart: cartReducer,
        inventory: inventoryReducer,
        order: orderReducer,
        search: searchReducer,
        [graceApi.reducerPath]: graceApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(graceApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
